namespace $ { $mol_style_attach( "piterjs/logo/logo.view.css",
 "[piterjs_logo] {\n\tdisplay: block;\n\twidth: 30vmin;\n\tbox-shadow: none;\n\tmargin: 1.5vmin;\n}\n\n[piterjs_logo_angles] {\n\t/* fill: var(--mol_theme_focus); */\n\tfill: #F7DF1E;\n}\n"
) }